import { fetchWebInteractives } from 'ContentData/api/WebInteractives';
import http from 'hub-http/clients/apiClient';
import { createRetryClient } from './apiClients';
const BASE_URL = 'web-interactives/v1';
const CONTENT_URL = `${BASE_URL}/cos-interactives`;

// TODO: Use this in web-interactives-dashboard-ui
export const createCTA = templatePath => {
  return http.post(CONTENT_URL, {
    data: {
      templatePath
    }
  });
};
export const getCTA = (id, buffer = false) => {
  let url = `${CONTENT_URL}/${id}`;
  if (buffer) {
    url = `${url}/buffer`;
  }
  return http.get(url);
};
export const updateCTAPublishState = ({
  id,
  unpublish = false
}) => {
  const actionType = unpublish ? 'cancel-publish' : 'schedule-publish';
  return http.postWithResponse(`${CONTENT_URL}/${id}/publish-action`, {
    data: {
      action: actionType
    }
  });
};

// Performs a hard update to the live CTA
export const updateCta = patchUpdate => {
  return http.put(`${CONTENT_URL}/${patchUpdate.id}`, {
    data: patchUpdate
  });
};
export const unpublishAllCTAs = () => {
  return fetchWebInteractives({
    name: '',
    count: 1000,
    offset: 0
  }).then(published => {
    const promises = published.results.map(crmItem => {
      const id = Number(crmItem.properties['hs_content_id'].value);
      return http.post(`${CONTENT_URL}/${id}/publish-action`, {
        data: {
          action: 'cancel-publish'
        }
      });
    });
    return Promise.all(promises);
  });
};
const retryClient = createRetryClient({
  retryOn400s: true
});
export const getInlineEmbedCode = (contentId, isInlineCta = false) => {
  const maybeSuffix = isInlineCta ? '/inline-html' : '';
  return retryClient.get(`${BASE_URL}/inline-embed/${contentId}${maybeSuffix}`);
};
export const getPreviewPages = (interactiveId, options = {}) => {
  const {
    query = '',
    offset = 0,
    limit = 100
  } = options;
  return http.get(`${BASE_URL}/editor/preview-pages`, {
    query: {
      interactiveId,
      query,
      offset,
      limit
    }
  });
};
export const cloneCtaToWebInteractive = (cta, migrationType) => {
  return http.post(`${CONTENT_URL}/create-from-legacy-cta`, {
    query: {
      migrationType
    },
    data: cta
  });
};
export const deleteWebInteractive = id => {
  return http.delete(`${CONTENT_URL}/${id}`);
};
export const cloneAndPublishCtaToWebInteractive = (cta, migrationType) => {
  return http.post(`${CONTENT_URL}/create-from-legacy-cta`, {
    query: {
      migrationType
    },
    data: cta
  }).then(result => {
    return updateCTAPublishState({
      id: result.id
    }).then(() => {
      return result;
    });
  });
};